"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SALES_PAGE_LIMIT = exports.DEFAULT_PAGE_LIMIT = void 0;
var DEFAULT_PAGE_LIMIT = 50;
exports.DEFAULT_PAGE_LIMIT = DEFAULT_PAGE_LIMIT;
var SALES_PAGE_LIMIT = 30;
exports.SALES_PAGE_LIMIT = SALES_PAGE_LIMIT;